export * from './operator.component';



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/operator.component/index.ts